import React from 'react';
import PropTypes from 'prop-types';
import { controlApi } from 'farmx-api';
import { useTranslation } from 'react-i18next';
import { pumpOverrideState } from '../../../../constants';
import OverrideButtons from './OverrideButtons';


export const VFD_TYPE = 'vfd';

const { createOverride, endOverride } = controlApi;

export default function PumpButtons(props) {
  const {
    pumpSchedule,
    pumpName,
    vfdIdentifier,
  } = props;
  const { t } =useTranslation();

  const statusLabels = {
    [pumpOverrideState.CLOSED]: {
      label1: t('OFF'),
      label2: t('Pump always off'),
    },
    [pumpOverrideState.OPEN]: {
      label1: t('ON'),
      label2: t('Pump always on'),
    },
    [pumpOverrideState.SCHEDULED]: {
      label1: t('SCHEDULED'),
      label2: t('Pump follows schedule'),
    },
  };

  return (
    <OverrideButtons
      sensorType={VFD_TYPE}
      sensorSchedule={pumpSchedule}
      sensorName={pumpName}
      sensorIdentifier={vfdIdentifier}
      statusLabels={statusLabels}
      sensorOverrideState={pumpOverrideState}
      createOverride={createOverride}
      endOverride={endOverride}
    />
  );
}

PumpButtons.defaultProps = {
  pumpSchedule: [],
  pumpName: '',
  vfdIdentifier: null,
};

PumpButtons.propTypes = {
  pumpSchedule: PropTypes.arrayOf(Object),
  pumpName: PropTypes.string,
  vfdIdentifier: PropTypes.string,
};
